import React, { useEffect, useRef } from 'react';
import ChatMessage from './ChatMessage';
import Icon from '../../../components/AppIcon';

const ChatContainer = ({ messages, isLoading }) => {
  const messagesEndRef = useRef(null);
  const containerRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  if (messages?.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="MessageCircle" size={32} color="white" strokeWidth={2} />
          </div>
          <h3 className="text-xl font-semibold text-text-primary mb-2">
            به دستیار مالی خوش آمدید
          </h3>
          <p className="text-text-secondary mb-6">
            من اینجا هستم تا در زمینه بودجه‌بندی، سرمایه‌گذاری، پس‌انداز و تمام پرسش‌های مالی به شما کمک کنم. کافیه هر سوالی داری از من بپرسی!
          </p>
          <div className="space-y-2 text-sm text-text-secondary">
            <p>💡 امتحان کن بپرسی: "کمکم کن یک بودجه ماهانه تنظیم کنم"</p>
            <p>📈 یا: "بهترین راه شروع سرمایه‌گذاری چیه؟"</p>
            <p>🏦 یا: "برای شرایط اضطراری چقدر باید پس‌انداز کنم؟"</p>
          </div>
        </div>
      </div>
    );
}

  return (
    <div 
      ref={containerRef}
      className="flex-1 overflow-y-auto bg-gray-50 p-4 pb-32"
      style={{ maxHeight: 'calc(100vh - 120px)' }}
    >
      <div className="max-w-4xl mx-auto">
        {messages?.map((msg, index) => (
          <ChatMessage
            key={index}
            message={msg?.content}
            isUser={msg?.isUser}
            timestamp={msg?.timestamp}
          />
        ))}
        
        {/* Loading Indicator */}
        {isLoading && (
          <div className="flex justify-start mb-4">
            <div className="max-w-xs lg:max-w-md xl:max-w-lg">
              <div className="flex items-end space-x-2">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-600 flex items-center justify-center">
                  <Icon name="Bot" size={16} color="white" strokeWidth={2} />
                </div>
                <div className="px-4 py-3 bg-white border border-border rounded-2xl rounded-bl-md shadow-soft">
                  <div className="flex space-x-1">
                    <div className="w-2 h-2 bg-text-secondary rounded-full animate-bounce"></div>
                    <div className="w-2 h-2 bg-text-secondary rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                    <div className="w-2 h-2 bg-text-secondary rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default ChatContainer;